import { imagePlaceholder } from "assets";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const LazyImage = ({
  effect = "blur",
  placeholderSrc = imagePlaceholder,
  ...rest
}) => {
  return <LazyLoadImage {...rest} {...{ effect, placeholderSrc }} />;
};

export default LazyImage;
